/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Grid, Card, Icon, Popup } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import TransUnionScoreBandPopup, {
  getColorForScore,
} from 'containers/Organizations/SingleOrganization/Profiles/SingleProfile/Requests/SingleRequest/TransUnionScoreBandPopup';

const MemberTransUnionScoreInfo = ({ data }) => {
  const transunion_score =
    data?.member_info?.user?.transunion_score || {};
  const newTransunionScore = data?.transunion_score || {};

  return (
    <Card
      className="member-save-score-info"
      style={{ width: '100%' }}
    >
      <Card.Content>
        <Grid className="">
          <Grid.Column width="16">
            <Grid.Row
              columns="1"
              className="member-save-score-info__row"
            >
              <Grid>
                <Grid.Column
                  columns="12"
                  className="member-save-score-info__50_percent"
                  style={{ width: '60%' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    TransUnion Score{' '}
                    <Popup
                      trigger={
                        <Icon name="info circle" color="blue" />
                      }
                      content={<TransUnionScoreBandPopup />}
                      on="click"
                      hoverable
                      position="left center"
                    />
                  </div>
                </Grid.Column>
                <Grid.Column
                  columns="4"
                  className="member-save-score-info__50_percent"
                  style={{ width: '40%' }}
                >
                  <div className="flex flex-center-vertical member-save-score-info__value">
                    <span
                      style={{
                        color: getColorForScore(530),
                        fontWeight: 'bold',
                        fontSize: '18px',
                        letterSpacing: '0.75px',
                        marginLeft: '5px',
                      }}
                    >
                      {newTransunionScore?.score_data
                        ?.positive_score ||
                        transunion_score?.score_data
                          ?.positive_score ||
                        'N/A'}
                    </span>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>

            <Grid.Row
              columns="1"
              className="member-save-score-info__row"
            >
              <Grid>
                <Grid.Column
                  columns="8"
                  className="member-save-score-info__50_percent"
                  style={{ width: '50%' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    Classification
                  </div>
                </Grid.Column>
                <Grid.Column
                  columns="8"
                  className="member-save-score-info__50_percent"
                  style={{ width: '50%' }}
                >
                  <div className="flex flex-center-vertical member-save-score-info__value">
                    <span
                      style={{
                        fontWeight: 'bolder',
                        fontSize: '16px',
                        letterSpacing: '0.75px',
                        marginLeft: '5px',
                      }}
                    >
                      {newTransunionScore?.score_data?.grade ||
                        transunion_score?.score_data?.grade ||
                        'N/A'}
                    </span>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>

            <Grid.Row
              columns="1"
              className="member-save-score-info__row"
            >
              <Grid>
                <Grid.Column
                  columns="8"
                  className="member-save-score-info__50_percent"
                  style={{ width: '50%' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    Default Probability
                  </div>
                </Grid.Column>
                <Grid.Column
                  columns="8"
                  className="member-save-score-info__50_percent"
                  style={{ width: '50%' }}
                >
                  <div className="flex flex-center-vertical member-save-score-info__value">
                    <span
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'right',
                        fontSize: '18px',
                        letterSpacing: '0.75px',
                        marginLeft: '5px',
                      }}
                    >
                      {newTransunionScore?.score_data?.probability ||
                        transunion_score?.score_data?.probability ||
                        'N/A'}
                    </span>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>
          </Grid.Column>
        </Grid>
      </Card.Content>
    </Card>
  );
};

MemberTransUnionScoreInfo.propTypes = {
  data: PropTypes.objectOf(Object).isRequired,
};

export default MemberTransUnionScoreInfo;
